import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Guard: пропускает только залогиненных платформ-админов.
 * Иначе — редирект на /login (UrlTree).
 */
export const platformAdminGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isLoggedIn() && auth.isPlatformAdmin()) {
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state?.url ?? '/' },
  });
};
